import { create } from "zustand";
import { persist } from "zustand/middleware";

export type DemoFormDraft = {
  name: string;
  phone: string;
  company: string;
  storesRange?: string;
  step: 1 | 2;
};

type DemoFormDraftStore = DemoFormDraft & {
  savedAt: number | null;
  saveDraft: (draft: Partial<DemoFormDraft>) => void;
  clearDraft: () => void;
};

// Rascunho do form de demo da landing. Persistido para o visitante que fecha o
// modal, navega pelo site ou recarrega a página voltar de onde parou. Expira
// para nome e WhatsApp não ficarem para sempre num navegador compartilhado.
const DRAFT_TTL_MS = 7 * 24 * 60 * 60 * 1000;

const EMPTY_DRAFT: DemoFormDraft = {
  name: "",
  phone: "",
  company: "",
  storesRange: undefined,
  step: 1,
};

export const useDemoFormDraftStore = create<DemoFormDraftStore>()(
  persist(
    set => ({
      ...EMPTY_DRAFT,
      savedAt: null,
      saveDraft: draft => set({ ...draft, savedAt: Date.now() }),
      clearDraft: () => set({ ...EMPTY_DRAFT, savedAt: null }),
    }),
    {
      name: "demo-form-draft",
      merge: (persisted, current) => {
        const draft = persisted as Partial<DemoFormDraftStore> | undefined;
        const isExpired =
          !draft?.savedAt || Date.now() - draft.savedAt > DRAFT_TTL_MS;
        return isExpired ? current : { ...current, ...draft };
      },
    }
  )
);
